import React, { SyntheticEvent, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useTrackSelect, useTrack } from '@app/analytics';

import { useOptionalField } from './FormikFields';
import { IllustratedSelectionBlock } from './IllustratedSelectionBlock';

interface Props {
  illustration?: string;
  title: string;
  description?: string;
  name: string;
  value?: string;
  i18nValues?: Object;
  i18nComponents?: React.ReactElement[];
  alone?: boolean;
  className?: string;
  disabled?: boolean;
  chip?: string;
  mobileDesign?: boolean;
  trackingName?: string;
}

export const IllustratedSelectionField = ({
  name,
  value,
  alone,
  mobileDesign = false,
  trackingName,
  ...rest
}: Props) => {
  const { field } = useOptionalField({ name });
  const formik = useFormikContext<any>();
  const track = useTrack();

  const _checked = Array.isArray(field?.value) && field?.value.includes(value);

  useEffect(() => {
    if (alone && formik && !_checked) {
      formik.setFieldValue(name, value);
    }
  }, [alone, formik, value, _checked, name]);

  const onChange = useTrackSelect(
    (e: SyntheticEvent<HTMLInputElement>) => {
      if (field.onChange) {
        field.onChange(e);
      }
      if (trackingName) {
        track(`${trackingName} Selected`, {
          label: value,
        });
      }
    },
    [field.onChange, trackingName, track],
  );

  return (
    <IllustratedSelectionBlock
      {...field}
      onChange={onChange}
      value={value}
      checked={_checked}
      mobileDesign={mobileDesign}
      {...rest}
    />
  );
};
